import { useEffect, useState } from 'react';

// Wspolny ruch bottom-sheetow (backdrop + panel) — jedno zrodlo prawdy, premium, z reduced-motion.
// Zasady:
//  - Panel: fizyczny spring (pewne wejscie z gladka decyzja), BEZ bounce (spojne z reszta ruchu app).
//  - Wyjscie SZYBSZE niz wejscie (exit-faster-than-enter) + ease-in (accel) = responsywnie, "schodzi z drogi".
//  - Backdrop zharmonizowany z panelem: ease-out na wejsciu, ease-in na wyjsciu, i NIE znika przed panelem.
//  - reduced-motion: sam fade, bez slajdu.
//  - "render-then-slide" (patrz useSheetSlideIn): sheet montuje sie z pelna trescia POD ekranem (y:100%),
//    ciezki KaTeX renderuje sie niewidocznie, i dopiero po wyrenderowaniu panel wjezdza (czysty transform).

export const getSheetBackdropMotion = () => ({
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.3, ease: [0.22, 1, 0.36, 1] } },
  exit: { opacity: 0, transition: { duration: 0.26, ease: [0.4, 0, 1, 1] } },
});

export const getSheetPanelMotion = (prefersReducedMotion, slideIn = true) => {
  if (prefersReducedMotion) {
    return {
      initial: { opacity: 0 },
      animate: { opacity: slideIn ? 1 : 0, transition: { duration: 0.2 } },
      exit: { opacity: 0, transition: { duration: 0.14 } },
    };
  }
  return {
    initial: { y: '100%' },
    animate: {
      y: slideIn ? 0 : '100%',
      transition: { type: 'spring', stiffness: 460, damping: 42, mass: 1 },
    },
    exit: { y: '100%', transition: { duration: 0.26, ease: [0.4, 0, 1, 1] } },
  };
};

// Gdy `shown` staje sie true, sheet montuje sie z pelna trescia (initial y:100%, POD ekranem).
// Ciezki render (KaTeX) dzieje sie synchronicznie w commicie Reacta — niewidocznie, bo panel jest
// poza ekranem. Dopiero po dwoch klatkach rAF (start slajdu nastepuje gdy klatka jest wolna) zwracamy
// true → panel wjezdza jako CZYSTY transform gotowej tresci. Zero janku widocznego, zero skoku wysokosci.
export const useSheetSlideIn = (shown) => {
  const [slideIn, setSlideIn] = useState(false);
  useEffect(() => {
    if (!shown) {
      setSlideIn(false);
      return undefined;
    }
    let r1 = 0;
    let r2 = 0;
    r1 = requestAnimationFrame(() => {
      r2 = requestAnimationFrame(() => setSlideIn(true));
    });
    return () => {
      if (r1) cancelAnimationFrame(r1);
      if (r2) cancelAnimationFrame(r2);
    };
  }, [shown]);
  return slideIn;
};
